<template>
	<div class="py-4 container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card mb-4">
					<div class="card-header pb-0">
						<h4>Scuderie</h4>
						<button
							type="button"
							id="add-btn"
							class="btn btn-primary"
							@click="clear"
							data-bs-toggle="modal"
							data-bs-target="#formModal"
						>
							+ {{ $t('add').toUpperCase() }}
						</button>
					</div>
					<div class="card-body px-0 pt-0 pb-2">
						<custom-table
							ref="table$"
							:rows="data"
							@action="runAction"
							:columns="[
								{
									title: 'Nome',
									type: 'text',
									data: 'name',
								},
								{
									title: 'Box',
									type: 'button-link',
									link: '/scuderie/:id',
									text: 'Vedi box',
								},
							]"
							:actions="[
								{
									title: 'Cancella',
									tooltip: 'delete',
									key: 'delete',
								},
								{
									title: 'Modifica',
									tooltip: 'edit',
									key: 'edit',
								},
							]"
							:pagination="pagination"
							@page-changed="handlePageChange"
							@update-pagination="handlePaginationUpdate"
							@search-changed="handleSearchChange"
						/>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade"
			id="formModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="add"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="formModalBtn">{{ modalTitle }}</h5>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							style="color: black; font-size: 2rem"
						>
							<span
								aria-hidden="true"
								class="d-block"
								style="margin-top: -0.5rem"
								>&times;</span
							>
						</button>
					</div>
					<div class="modal-body">
						<Vueform ref="form$" v-model="horseStable" sync>
							<HiddenElement name="id" />
							<text-element
								name="name"
								:label="$t('first_name')"
								rules="required"
							></text-element>
						</Vueform>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							id="close"
							class="btn btn-secondary"
							data-bs-dismiss="modal"
						>
							Chiudi
						</button>
						<button
							type="button"
							class="btn btn-primary"
							:class="{ loading: loading }"
							@click="save"
						>
							Salva
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { horseStablesService } from '@/services/HorseStablesService';
	import CustomTable from '@/components/CustomTable';
	import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
	import { useTableData } from '../../../src/composables/useTableData';
	import { useToast } from 'vue-toastification';
	const toast = useToast();

	export default {
		name: 'Maneggio',
		components: { CustomTable },
		data() {
			return {
				horseStable: {},
				horseStables: [],
				loading: false,
				modalTitle: this.$t('add'),
			};
		},
		computed: {
			ridingId() {
				return this.$store.state.user.riding_stables[0].id;
			},
		},
		setup() {
			const tableData = useTableData(
				horseStablesService.getHorseStables.bind(horseStablesService),
				10
			);
			return tableData;
		},

		methods: {
			runAction({ action, row }) {
				this.loading = true;
				if (action.key == 'edit') {
					this.modalTitle = this.$t('edit');
					this.horseStable = horseStablesService.getHorseStableById(row.id);
					this.horseStable.id = row.id;
					this.loading = false;
					const modalElement = document.getElementById('formModal');
					const myModal = new bootstrap.Modal(modalElement);
					myModal.show();
				} else if (action.key == 'delete') {
					this.deleteHorseStable(row.id);
				}
			},

			clear() {
				this.horseStable = {};
				this.$refs.form$.reset();
				this.modalTitle = this.$t('add');
			},

			async save() {
				const form = this.$refs.form$;
				form.validate();
				if (this.horseStable.id) form.data.id = this.horseStable.id;
				if (!form.hasErrors) {
					for (const key in form.data) {
						if (form.data[key] === 'null' || form.data[key] === null) {
							delete form.data[key];
						}
					}
					this.loading = true;
					console.log(form.data);
					try {
						await horseStablesService.saveHorseStalble(
							this.ridingId,

							form.data
						);
						toast(this.$t('operation_saved'));
						document.getElementById('close').click();
						this.fetchHorseStables();
					} finally {
						this.loading = false;
					}
				}
			},

			fetchHorseStables() {
				this.fetchData({
					riding_stable_id: this.ridingId,
				});
			},

			async deleteHorseStable(horseStable_id) {
				if (
					!confirm(
						this.$t('irreversible_action') + '\n' + this.$t('do_u_confirm')
					)
				)
					return;
				await horseStablesService.deleteHorseStable(
					this.ridingId,
					horseStable_id
				);
				this.fetchHorseStables();
			},
		},
		created() {
			this.$store.dispatch('updateBreadcrumbs', [
				{ title: 'Scuderie', name: 'Scuderie' },
			]);
		},
		mounted() {
			this.fetchHorseStables();
		},
	};
</script>
